"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBProductHeader", {
  enumerable: true,
  get: function get() {
    return _SVBProductHeader.default;
  }
});
var _SVBProductHeader = _interopRequireDefault(require("./src/SVBProductHeader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }